export function consoleHello() {
    console.log(`
_____         _   _            ____                              
|     |___ ___| |_|_|_ _ ___   |    \ _ _ ___ ___ ___ ___ ___ ___ 
| | | | . | -_| . | | | |_ -|  |  |  | | |   | . | -_| . |   |_ -|
|_|_|_|___|___|___|_|___|___|  |____/|___|_|_|_  |___|___|_|_|___|
                                            |___|  
MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMMMMMMMMMWKOkdlc:ccccdk0NMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMMMMMMMMM0,            .:0MMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMMMMMMMMMNd'.  .'..   ..cKMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMNKd.....  l0XWMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMMMMMMMMWXKOOd. .;c..ckxdddxxxOKXWMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMMWKxol::cc::, .:lo, ':cloolllllllllox0NMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMN0xlc:;,;coOXWMMk..,''..OMMMMMMMMMMWXKOxol:lKWMMMMMMMMMMMMM
MMMMMMMMMMMMMNkc,,:ox0XWMMMMMMMM0'.',;..OMMMMMMMMMMMMMMMMW0c,c0WMMMMMMMMMMM
MMMMMMMMMMMXd;,ckXWMMMMMMMMMMMMMK,.':l..kMMMMMMMMMMMMMMMMMMWKl,cOWMMMMMMMMM
MMMMMMMMWKo,,dXMMN0O0XXKKOkdoccc;..cdd' 'ccllloodk000KNWMMMMMMKl'cKMMMMMMMM
MMMMMMW0c.,dNMMKo,. .....          ..               ..':kWMMMMMWO;,xNMMMMMM
MMMMMXl.'xXMMMMx.       .....      .'..    .;,,,,,.     .OMMMMMMMNo':KMMMMM
MMMMK;.cKMMMMMMW0occldkO00KX0o, 'o:;'...cc.oMWWWWWXOdoodONMMMMMMMMWO,'OMMMM
MMMK;'kWMMMMMMMMMWNWMMMMMMMMMMO.:NW0, 'OWx.,xdddx0XWMMMMMMXOXMMMMMMM0,'OMMM
MMX:.kWMMMMMMMMMWd:0MWX0Okxocc;.:NMX; ,KMo.':;;;;;,;dKMMMMXkOxkWMMMMMk.:NMM
MWd.lWMMMMMMMMMMWd':l:..  .:::;..ll:. .:c' 'cloxkko:''oKWWWWM0kNMMMMMN:'0MM
MN:.xMMMMMMMMMMMMWKxcc:'  .:cclooodxddxO00kO0kdolccc:'.,llloONMMMMWWMMd.oMM
MWo.dMMMMMMMMMMMMMMW0l;:;.:XWMMMMMMWNXddNMMMMMMMMMNXXKKKKXXXNMMMMM0ONMx.:NM
MMO.cWMMMMMMMMMMMMKl..:c,.,KMMMMMMMKo:'':lOWMMMMMMMMMMMMMMWWMMMMMMWWMMd.oWM
MMNc'OMMMMMMMMMMM0,  .:l, cNMMMMMMMWXKK0OOKWMMMMMMMMMMMMMXocOWMM0kNMMMo.xMM
MMM0,:XMMMMMMMMWk'.;dKKl.:KMMMMWWWMMMMMMMMMWN0OXWMMMMMMMMWKo:OMM0ONMMK,,KMM
MMMMO,:XMMMMMMMO',O0xc',xNN0dl:,;lllkXNMNOo;,coONMMMMMMMMMMN0XMMMMMMK;.kWMM
MMMMMO,;0WMMMMN: .'..;xXNk:,cl' 'OKx,.lO:    ,:::ldO0XNWMMMMMMMMMWKd,;OWMMM
MMMMMM0;.cOXWM0',xxOKWMNl.lXMX; .kMN: ...',;cxKKOdc::,',:lllc:;c:'.,xNMMMMM
MMMMMMMNkc;,;c:.colKMMMx.lWMMK, .kWx.  ;0NNWMMMMMMMMNKkxxdolc:;,,;.:XMMMMMM
MMMMMMMMMMNOxoc.:k:lNMMk'oWMMK, .;:.,:dXMOcOMMMMXxKMMMMMMMMMMMMWWK,.OMMMMMM
MMMMMMMMMMMWXd;,,:coXMMWklool;.  'lONMMMMK:lXMMMKd0MMMMMMMMMMMMMNo.;KMMMMMM
MMMMMMMMWk:;.,lo;,coookOkxo:'';dONMMMMMMMM0l0MMMMMMMMMMMMMMMMMW0:.cXMMMMMMM
MMMMMMMMMXc.;k:'dXMMXkdolloxOXWMMMMMMMMMMMWXNMMMMMMMMMMMMMMMNx,.'xNMMMMMMMM
MMMMMMMMMMKdOl.kWMMMMMMMMMMMMMMMMMWXOxxxO0000kxdlclllllloool;',oKMMMMMMMMMM
MMMMMMMMMMMMK,:NMMMMMMMMMMMMMMMMXxc,. .:c,... ,odk0Okkkxo..lk0NMMMMMMMMMMMM
MMMMMMMMMMMMX;;KMMMMMMMMMMMMMMNd;;xo. lWWc ;xk0WMMMMMMW0:'dWMMMMMMMMMMMMMMM
MMMMMMMMMMMMMO,cXMMMXoxWMMMMM0;.lNMx..oMN:.OMM0dXMMMW0c':0WMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMM0c:kWMNkoKMMMMM0,.dMMo.'xMN:'0MMXKNW0d:,cOWMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMNx,oNMWKXMMMMMMd.oMWc.cOMX;,0NX0kl:;cxXWMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMWO:cOWWWMMMMMMk.cWWc'lOMk..clcccoOXMMMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMNxcloOKKKK0Ol.'0MOccOX: cXNWMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMWKxoolllc:cc';KWWNWx..OMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMWO,,OWM0,.dWMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMKc'co,.oNMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMNkc:oKWMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM

Created by Sean Yager, (c) Misuse of Mana LLC.

If you're a game dev company or individual looking to hire an artist with
full stack front end designer with backend knowledge, experience with Vue,
React, Webpack, and Node.js, send me an email.

I'm a former web dev student of Austin Coding Academy, and
would love to hear from you.

contact@seanyager.com
`);
}